export function composeModalRenderers(...rendererFns) {
    return (modalType, requestClose, params)=>{
        for (const renderer of rendererFns){
            const result = renderer(modalType, requestClose, params);
            if (result) {
                return result;
            }
        }
        return null;
    };
}
